<ml-error-page [additionalText]="additionalText"/>
<div class="justify-sticky-buttons-center">
  <a mat-flat-button color='primary' (click)="back()" class="do-not-display-as-a-link space-top-2">{{ 'application.error-page.button' | translate }}</a>
</div>
